const firebaseConfig = {
    apiKey: "AIzaSyADodcd1wbL_tCEiPPKxJuV1QTDcpYRTuo",
    authDomain: "dreico-development.firebaseapp.com",
    projectId: "dreico-development",
    storageBucket: "dreico-development.appspot.com",
    messagingSenderId: "685208698096",
    appId: "1:685208698096:web:1bbefda69d7ed322289635"
};

export default firebaseConfig